import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminProduto: Routes = [
  {
    path: 'categoria_produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PROD_CATEGORIA_PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Categoria de produtos',
        icon: 'mdi mdi-shape-outline'
      },
      backend_path: '/categoria_produtos'
    },
    loadChildren: () =>
      import('@app/modules/categoria-produtos/categoria_produto.module').then(
        m => m.CategoriaProdutoModule
      )
  },
  {
    path: 'tabela_preco',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PROD_TABELA_PRECO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Tabela de preço',
        icon: 'mdi mdi-file-table-box-multiple-outline'
      },
      backend_path: '/tabela_preco'
    },
    loadChildren: () =>
      import('@app/modules/tabela-preco/tabelapreco.module').then(
        m => m.TabelaPrecoModule
      )
  },
  {
    path: 'produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Produtos',
        icon: 'pi pi-fw pi-box'
      },
      backend_path: '/produtos'
    },
    loadChildren: () =>
      import('@app/modules/produto/produto.module').then(m => m.ProdutoModule)
  },
  {
    path: 'produto_variacoes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRODUTO',
      module: 'GRADE_PRODUTO',
      breadcrumb: {
        label: 'Grade de produto',
        icon: 'mdi mdi-sitemap'
      },
      backend_path: '/produto_variacoes'
    },
    loadChildren: () =>
      import('@app/modules/produto/produto_grade.module').then(
        m => m.ProdutoGradeModule
      )
  },
  {
    path: 'variacao_produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PROD_VARIACAO_PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Variações de produto',
        icon: 'mdi mdi-vector-difference-ba'
      }
    },
    loadChildren: () =>
      import('@app/modules/variacao-produtos/variacao-produtos.module').then(
        m => m.VariacaoProdutosModule
      )
  },
  {
    path: 'entrada_produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'REE_PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Entradas',
        icon: 'mdi mdi-archive-arrow-down-outline'
      },
      backend_path: '/ree_produtos'
    },
    loadChildren: () =>
      import('@app/modules/entrada-produtos/entrada.module').then(
        m => m.EntradaProdutosModule
      )
  },
  {
    path: 'saida_produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'RSE_PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Saídas',
        icon: 'mdi mdi-archive-arrow-up-outline'
      },
      backend_path: '/rse_produtos'
    },
    loadChildren: () =>
      import('@app/modules/saida-produtos/saida.module').then(
        m => m.SaidaProdutosModule
      )
  },
  {
    path: 'entrada_via_pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'TPE_PRODUTO',
      menuKey: 'PRODUTO',
      breadcrumb: {
        label: 'Entrada via pedidos',
        icon: 'mdi mdi-swap-horizontal'
      },
      backend_path: '/tpe_produtos'
    },
    loadChildren: () =>
      import(
        '@app/modules/entrada-via-pedidos/entrada_via_pedidos.module'
      ).then(m => m.TpeModule)
  }
];
